import { useEffect, useState, type MutableRefObject } from "react";
import type { ChatMessage, PairingClient } from "../protocol";

/** The open idea's discussion thread. Resubscribes when the selection or open idea changes. */
export function useIdeaThread(
  clients: MutableRefObject<Map<string, PairingClient>>,
  selected: string | null,
  openIdea: string | null,
  /** From useSessions — re-runs the subscription once the client for this selection exists (see useSessions). */
  clientsVersion: number,
): ChatMessage[] {
  const [ideaMessages, setIdeaMessages] = useState<ChatMessage[]>([]);
  useEffect(() => {
    if (!selected || !openIdea) {
      setIdeaMessages([]);
      return;
    }
    const [pid, sid] = selected.split("/");
    const unsub = clients.current.get(pid)?.subscribeChannelChat(sid, openIdea, setIdeaMessages);
    return () => unsub?.();
  }, [selected, openIdea, clientsVersion]);
  return ideaMessages;
}
